import { Link } from 'react-router-dom';
import { Instagram, Linkedin, Youtube, Phone } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="bg-secondary border-t border-themed">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="md:col-span-2">
            <h3 className="text-2xl font-black lowercase mb-4 text-primary">
              appdroid ai<span className="text-purple-700">.</span>
            </h3>
            <p className="text-muted text-sm max-w-md mb-6">
              Where Intelligence Meets Imagination.
            </p>
            <div className="flex gap-4">
              <a
                href="https://www.instagram.com/appdroidai/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-card border border-themed rounded-full flex items-center justify-center hover:bg-purple-500/20 hover:border-purple-500 transition-all text-primary"
              >
                <Instagram size={18} />
              </a>
              <a
                href="https://www.linkedin.com/company/appdroidtechsolutions/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-card border border-themed rounded-full flex items-center justify-center hover:bg-purple-500/20 hover:border-purple-500 transition-all text-primary"
              >
                <Linkedin size={18} />
              </a>
              <a
                href="https://www.youtube.com/@appdroidtechsolution537/videos"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-card border border-themed rounded-full flex items-center justify-center hover:bg-purple-500/20 hover:border-purple-500 transition-all text-primary"
              >
                <Youtube size={18} />
              </a>
              <a
                href="https://wa.me/918999809160"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-card border border-themed rounded-full flex items-center justify-center hover:bg-purple-500/20 hover:border-purple-500 transition-all text-primary"
              >
                <Phone size={18} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-xs font-bold tracking-[0.2em] uppercase text-purple-500 mb-4">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/services" className="text-sm text-muted hover:text-primary transition-colors">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/work" className="text-sm text-muted hover:text-primary transition-colors">
                  Work
                </Link>
              </li>
              <li>
                <Link to="/clients" className="text-sm text-muted hover:text-primary transition-colors">
                  Clients
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm text-muted hover:text-primary transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-xs font-bold tracking-[0.2em] uppercase text-purple-500 mb-4">Contact</h4>
            <ul className="space-y-3">
              <li className="text-sm text-muted">contact@appdroidtech.com</li>
              <li className="text-sm text-muted">+91 8999809150 | +91 8788343984</li>
              <li className="text-sm text-muted">Jalgaon, Maharashtra</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-themed mt-12 pt-8 text-center">
          <p className="text-sm text-muted">
            © 2026 Appdroid AI Innovations Pvt. Ltd. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};